import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CatCommissionCalendarModel } from 'src/oldApp/model/cat-commission-calendar.model';

@Injectable({
  providedIn: 'root'
})
export class CatCommissionCalendarService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  getAll=()=> {
    return this.http.get(`${this.url}/cat-commission-calendar/list`)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  getAllActive=()=> {
    return this.http.get(`${this.url}/cat-commission-calendar/list`)
      .pipe(
        map((resp:any)=> resp.filter(cal=> cal.activeId))
      );
  }
  save=(calendar:CatCommissionCalendarModel)=> {
    return this.http.post(`${this.url}/cat-commission-calendar/save`, calendar)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(calendar:CatCommissionCalendarModel)=> {
    return this.http.post(`${this.url}/cat-commission-calendar/update/${calendar.commissionCalendarId}`, calendar)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
